import comp from "./ProfileCascade";
export default comp;
